const FaqData = [
  {
    id: 0,
    title: "What services does CaresAtHome provide?",
    content: "We provide nursing care, physiotherapy, bedside attendants, ICU setup, doctor consultations, diagnostics, emergency services, and medical equipment support."
  },
  {
    id: 1,
    title: "Can I book healthcare services at home?",
    content: "Yes, you can easily book healthcare services at home through our website or mobile app with flexible scheduling options."
  },
  {
    id: 2,
    title: "Are your caregivers and nurses verified?",
    content: "Yes, all our healthcare professionals, nurses, and caregivers are trained, experienced, and verified for safe and reliable patient care."
  },
  {
    id: 3,
    title: "Do you provide emergency medical support?",
    content: "Yes, we offer emergency healthcare assistance, ICU support, oxygen setup, and urgent medical services based on patient needs."
  },
  {
    id: 4,
    title: "How can I book an appointment?",
    content: "You can book appointments online through our app or website by selecting your required service, preferred date, and location."  
},
  {
    id: 5,
    title: "Do you provide medical equipment on rent?",
    content: "Yes, we provide medical equipment such as oxygen concentrators, ICU beds, wheelchairs, monitors, and other healthcare devices for home and hospital use." 
 },
   {
    id: 6,
    title: "Is online doctor consultation available 24/7?",
    content: "Yes, our platform offers online doctor consultation services with experienced healthcare professionals for medical guidance and follow-up support." 
 }
  
];

export default FaqData;